import { ViewApi } from './types';

const view: ViewApi = {
  continueClicked() {
    if (this.viewApi === undefined) {
      throw new Error('SDK has not been initialized yet.');
    }

    return this.viewApi.continueClicked();
  },
};

export { view };

export { type ViewApi } from './types';
